import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListDeviations } from "../../../components/Admin/Deviations/ListDeviations/ListDeviations";
import { useLanguage } from "../../../contexts";
import "./Deviations.scss";

export function Deviations() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("actives"),   render: () => <Tab.Pane attached={false}><ListDeviations active={true}  reload={reload} onReload={onReload} /></Tab.Pane> },
    { menuItem: t("inactives"), render: () => <Tab.Pane attached={false}><ListDeviations active={false} reload={reload} onReload={onReload} /></Tab.Pane> },
  ];

  return (
    <div className="deviations-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="deviations-page-header-wrapper">
        <div className="deviations-page-header">
          <span className="deviations-page-title">{t("deviations")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
